import React, { useEffect, useState } from "react";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import { createStyles, makeStyles } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { IAppStore } from "../../../types/IAppStore";
import { getWidgetsSettings, updateWidgetsSettings } from "../../../actions/restaurantsWidgetsSettings/RestaurantsWidgetsSettingsActions";

const styles = createStyles({
  container: {
    padding: "0 24px 16px 24px",
  },
});

const useStyles = makeStyles(styles);

export const WidgetsSettings = () => {
  const classes = useStyles(styles);
  const dispatch = useDispatch();
  const settings = useSelector((state: IAppStore) => state.widgetsSettings?.settings);

  useEffect(() => {
    dispatch(getWidgetsSettings())
  }, [])

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateWidgetsSettings({
      isShowAvailableTablesCount: event.target.checked,
    }));
  };

  return (
    <div className={classes.container}>
      <FormControlLabel
        control={
          <Switch
            checked={settings.isShowAvailableTablesCount}
            onChange={handleChange}
            color="primary"
          />
        }
        label="Показывать количество доступных столов в виджете"
      />
    </div>
  );
};
